import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../stores/hooks/hooks.ts";
import { CreatorOverviewSlideOut } from "./components/CreatorOverviewSlideOut.tsx";
import { useEffect } from "react";
import { fetchCreatorById } from "../../../../../../stores/thunks/creatorsThunk.tsx";
import {
  RevAvatar,
  RevIconButton,
  RevSlideout,
  RevSpinner,
} from "@revmatics/catalyst";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { getScoreTextColor } from "./data.ts";

type Props = {
  creatorId: string | null;
  setIsOpen: () => void;
  menu: string | null;
};

export const CreatorOverview = ({ creatorId, setIsOpen, menu }: Props) => {
  const creatorById = useAppSelector((state) => state.creators.creatorById);
  const isLoadingById = useAppSelector((state) => state.creators.isLoadingById);
  const dispatch = useAppDispatch();
  const creatorIdNum = Number(creatorId);

  useEffect(() => {
    if (creatorId && creatorIdNum !== creatorById?.id) {
      dispatch(fetchCreatorById(creatorIdNum));
    }
  }, [dispatch, creatorById, creatorIdNum, creatorId]);

  return (
    <RevSlideout
      isOpen={!!creatorId}
      setIsOpen={setIsOpen}
      size="lg"
      data-testid="creator-overview-panel"
      headerComponent={
        creatorById?.id.toString() === creatorId ? (
          <div className="px-6 py-4 bg-white sticky top-0 z-10 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <RevAvatar
                variant="circle"
                size="medium"
                theme="light"
                image={
                  creatorById?.creator_image_link ||
                  creatorById?.creator_image_file ||
                  ""
                }
                firstName={creatorById?.name.split(" ")[0]}
                lastName={creatorById?.name.split(" ").pop()}
              />
              <h5 data-testid="creator-overview-name-heading">
                {creatorById?.name}
              </h5>
            </div>
            <div className="flex items-center gap-6">
              {!!creatorById?.ai_score && (
                <div className="flex flex-col justify-end">
                  <p className="typography-body-xs text-monochrome-600 whitespace-nowrap">
                    AI Score
                  </p>
                  <h4
                    className={`${getScoreTextColor(Math.round(creatorById?.ai_score))} text-end`}
                  >
                    {Math.round(creatorById?.ai_score)}
                  </h4>
                </div>
              )}
              <RevIconButton icon={faXmark} size="l" handleClick={setIsOpen} />
            </div>
          </div>
        ) : (
          <div className="h-[86px] px-6 bg-white sticky top-0 z-10 flex items-center justify-end">
            <RevIconButton icon={faXmark} size="l" handleClick={setIsOpen} />
          </div>
        )
      }
    >
      {isLoadingById && <RevSpinner size="large" centered color="primary" />}
      {creatorById && !isLoadingById && (
        <CreatorOverviewSlideOut menu={!!menu} />
      )}
    </RevSlideout>
  );
};
